<template>
  <div>
    <form @submit.prevent="addResponse">
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <strong>Create A Response</strong> Elements
                    </div>
                    
                        <b-form-group
                            label="Response Customer:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="responsecustomer" type="text" v-model="response.customer"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Response Member:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="responsemember" type="text" v-model="response.member"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Response Title:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="responsetitle" type="text" v-model="response.title"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Date" label-for="date"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input type="date" id="date"  v-model="response.date"></b-form-input>
                        </b-form-group>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-10"></div>
                                <div class="col-md-2">
                                    <button class="btn btn-primary">Create</button>
                                </div>
                            </div>
                        </div>  
                </b-card>
            </b-col>
        </b-row>
    </form>
  </div>
</template>

<script>
export default {
    name: 'responsesadd',
    data(){
        return {
        response:{}
        }
    },
    methods: {
        addResponse(){
            let uri = `${process.env.VUE_APP_API_BASE_URL}/responses/add`;
            this.axios.post(uri, this.response).then(() => {
                this.$router.push({name: 'Responses'});
            });
        }   
    }
}
</script>